// extracted by mini-css-extract-plugin
export default {"loginFormWrap":"Login_loginFormWrap__aMlhn"};